<template>

    <ThemeChanger :to="Theme.Default">

        <Container fluid class="pt-32 md:pt-48">

            <PageHeader :header="post?.title" :sub-header="`${ post?.updated_at } · Written by ${ post?.author?.name }`" :header-span="5"/>

        </Container>

        <!-- <BlockRevealAnimation> -->

            <Grid fluid class="pt-24" v-if="post.cover">

                <div class="flex justify-center ow-post__cover">

                    <Picture :image="post.cover" height="100%" maxHeight="100%" width="100%" maxWidth="100%" :lazy="false"/>

                </div>

            </Grid>

        <!-- </BlockRevealAnimation> -->

        <Container class="mt-24" fluid>

            <BlogContent v-for="(item, index) of post.body" :key="index" :data="item" :index="index"/>

        </Container>

    </ThemeChanger>

    <MetaInfo v-if="post.seo" :seo="post.seo" :structured-data="post.seo_structured_data"/>

</template>

<script lang="ts">

    import { defineComponent, getCurrentInstance, ref, watchEffect, nextTick } from 'vue'
    import Container from '../components/Container.vue'
    import Grid from '../components/Grid/Grid.vue'
    // import BlockRevealAnimation from '../components/BlockRevealAnimation.vue'
    import PageHeader from '../components/PageHeader.vue'
    import Picture from '../components/Picture.vue'
    import BlogContent from '../components/Blog/BlogContent.vue'
    import MetaInfo from '../components/MetaInfo.vue'
    import ThemeChanger from '../components/ThemeChanger.vue'
    import { Theme } from '../enums/Theme'
    import { Route } from '../enums/Route'
    import { useCms } from '../compositions/UseCms'
    import { useTheme } from '../compositions/UseTheme'
    import { useRoute, useRouter } from 'vue-router'

    export default defineComponent({
        name: 'BlogPost',
        components: {
            // BlockRevealAnimation,
            Container,
            Grid,
            BlogContent,
            PageHeader,
            Picture,
            MetaInfo,
            ThemeChanger
        },
        setup() {

            const route = useRoute()
            const router = useRouter()
            const { blogs, isCNLocale } = useCms()
            const refreshAOSHard = getCurrentInstance()?.appContext.config.globalProperties.$aos?.refreshHard
            const post = ref<any>('')
            useTheme().initializeCurrentThemeBasedOnRouteMeta()

            watchEffect(() => {

                if (route.name === Route.BlogPost) {

                    const path = isCNLocale.value ? `/cms/cn/blogs/${ route.params.slug }.json` : `/cms/en/blogs/${ route.params.slug }.json`

                    fetch(path)
                        .then(response => response.json())
                        .then(response => {

                            post.value = response as any

                        })
                        .then(nextTick)
                        .then(() => {

                            refreshAOSHard?.()

                        })
                        .catch(err => {

                            console.log(err)
                            router.replace({ name: Route.NotFound })

                        })

                }

            })

            return {
                Theme,
                cms: blogs,
                post
            }

        }
    })

</script>

<style lang="scss">

    @include component(ow-post) {

        @include part(cover) {

            @apply w-full;

            max-width: 1540px;

            @screen lg {

                width: calc(100% - ((2.5rem + 15px) * 2));
                margin: 0 auto;

                video {

                    @screen lg {

                        @apply object-cover h-full w-full;

                    }

                }

            }

        }

    }

</style>
